export default {
    data() {
        return {
            tmpValue: [],
            options: [],
            loading: false,
        }
    },
    created() {
        if (this.value.length > 0) {
            this.tmpValue = this.value.map(val => val.numericValue)
            _.map(this.value, (val) => {
                if(val.autocompleteValue){
                    this.options.push(val.autocompleteValue)
                }
            })
        }
    },
    computed: {
    },
    methods: {
        remove(removed) {
            let checkAlreadayInValue = this.value.length > 0 ? this.value.find(val => val.numericValue == removed) : false
            if (checkAlreadayInValue) {
                this.$emit('remove', checkAlreadayInValue)
            } else {
                let buildData = JSON.parse(JSON.stringify(this.templateData))
                buildData.numericValue = removed
                this.$emit('remove', buildData)
            }
        },
        formatAndEmit(values){
            if (values.length > 0) {
                values.map(value => {
                    let checkAlreadayInValue = this.value.length > 0 ? this.value.find(val => val.numericValue == value) : false
                    if (checkAlreadayInValue) {
                        checkAlreadayInValue.autocompleteValue = this.options.find(option => option.id == value)
                        this.$emit('input', checkAlreadayInValue)
                    } else {
                        let buildData = JSON.parse(JSON.stringify(this.templateData))
                        buildData.numericValue = value
                        buildData.autocompleteValue = this.options.find(option => option.id == value)
                        this.$emit('input', buildData)
                    }
                })
            }
        }
    },
    watch: {
        tmpValue(newValue, oldValue) {
            if (newValue.length != oldValue.length) {
                let valid = this.checkParams(newValue)
                if (!valid) {
                    this.$refs[this.reference].blur()
                    this.$emit('error', { name: this.reference, message: this.$l10n.__('Limite atteinte') })
                } else {
                    if (newValue.length < oldValue.length) {
                        this.remove(oldValue.filter(value => !newValue.includes(value)))
                    }
                    if (newValue.length > 0) {
                        this.formatAndEmit(newValue)
                    }
                }
            }
        },
        value: {
            handler: function (newValue) {
                this.tmpValue = newValue.map(val => val.numericValue)
                this.options = []
                newValue.map(val => {
                    if (val.autocompleteValue){
                        this.options.push(val.autocompleteValue)
                    }
                })
            },
            deep: true
        }
    }
}